import { ALLOW_COOKIE } from 'constants';
import Storage from 'utilities/storage';

export const checkSessionTimeLeftWithToken = ({ accessToken, checkSession }) => {
    const token = accessToken || (ALLOW_COOKIE && Storage.cookies.get('accessToken'));
    if (!token) return;
    checkSession(token);
};
